import { render, staticRenderFns } from "./3D Coverflow effect.vue?vue&type=template&id=1ad97a40&scoped=true&"
import script from "./3D Coverflow effect.vue?vue&type=script&lang=js&"
export * from "./3D Coverflow effect.vue?vue&type=script&lang=js&"
import style0 from "./3D Coverflow effect.vue?vue&type=style&index=0&id=1ad97a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad97a40",
  null
  
)

export default component.exports